import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, setShowBackdrop } from "../uiSlice";
import { getReporteAdmin, getReporteAjustes, getReporteMicro, getReporteSatisfaccion, getReporteSeguimientoMicro } from "../../Services/reporte_service";
import { setResponse } from "../Response/responseSlice";

const initialState = {
    reporteSeguimiento: [],
    reporteAjustesDetalle: [],
    reporteAjustesPrincipal: [],
    reporteSatisfaccion: [],
    reporteBasico: [],
    fechaInicio: new Date(),
    fechaFin: new Date(),
}

export const reporteSlice = createSlice({
    name: 'reporte',
    initialState,
    reducers: {
        setReporteBasico: (state, action) => {
            state.reporteBasico = action.payload;
        },
        setReporteSatisfaccion: (state, action) => {
            state.reporteSatisfaccion = action.payload;
        },
        setReporteAjustesDetalle: (state, action) => {
            state.reporteAjustesDetalle = action.payload;
        },
        setReporteAjustesPrincipal: (state, action) => {
            state.reporteAjustesPrincipal = action.payload;
        },
        setReporteSeguimientoMicro: (state, action) => {
            state.reporteSeguimiento = action.payload;
        },
        setFechaInicio: (state, action) => {
            state.fechaInicio = action.payload;
        },
        setFechaFin: (state, action) => {
            state.fechaFin = action.payload;
        },
        resetReport: () => initialState,
    }
});

export const fetchReporteBasico = createAsyncThunk(
    'reporte/fetchReporteBasico',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        data.fechaInicio.setUTCHours(0, 0, 0, 0);
        data.fechaFin.setUTCHours(23, 59, 59, 999);
        const params = {
            fechaInicio: data.fechaInicio,
            fechaFin: data.fechaFin,
        };

        if (data.idSegmento) {
            params.idSegmento = data.idSegmento;
        } else {
            params.sucursal = data.sucursal ?? -1;
            params.region = data.region ?? -1;
            if (data.cartera) {
                params.cartera = data.cartera;
            }
        }
        const reporteRes = await getReporteAdmin(params);
        dispatch(setReporteBasico(reporteRes ?? []));
        dispatch(setShowBackdrop(false));
    }
);

export const fetchReporteMicroaprendizaje = createAsyncThunk(
    'reporte/fetchReporteMicroaprendizaje',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        data.fechaInicio.setUTCHours(0, 0, 0, 0);
        data.fechaFin.setUTCHours(23, 59, 59, 999);
        const params = {
            fechaInicio: data.fechaInicio,
            fechaFin: data.fechaFin,
            idSegmento: data.idSegmento
        };

        const reporteRes = await getReporteMicro(params);
        dispatch(setReporteBasico(reporteRes ?? []));
        dispatch(setShowBackdrop(false));
    }
);

export const fetchReporteSatisfaccion = createAsyncThunk(
    'reporte/fetchReporteSatisfaccion',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));
        data.fechaInicio.setUTCHours(0, 0, 0, 0);
        data.fechaFin.setUTCHours(23, 59, 59, 999);
        const reporteRes = await getReporteSatisfaccion(data);
        dispatch(reporteRes?.result
            ? setReporteSatisfaccion({ ...reporteRes, data: reporteRes.data ?? [] })
            : setReporteSatisfaccion([]));
        dispatch(setLoading(false));
    }
);

export const fetchReporteAjustes = createAsyncThunk(
    'reporte/fetchReporteAjustes',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        const reporteRes = await getReporteAjustes(data);
        if (reporteRes?.result) {
            dispatch(setReporteAjustesPrincipal(reporteRes?.data?.principal ?? []));
            dispatch(setReporteAjustesDetalle(reporteRes?.data?.detalle ?? []))

            if (!reporteRes?.data?.detalle)
                dispatch(setResponse({ result: -1, message: 'No se encontraron ajustes' }));
        }
        dispatch(setShowBackdrop(false));
    }
);

export const fetchReporteSeguimientoMicroaprendizaje = createAsyncThunk(
    'reporte/fetchReporteMicroaprendizaje',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        data.fechaInicio.setUTCHours(0, 0, 0, 0);
        data.fechaFin.setUTCHours(23, 59, 59, 999);
        const params = {
            fechaInicio: data.fechaInicio,
            fechaFin: data.fechaFin,
            idSegmento: data.idSegmento
        };

        const reporteRes = await getReporteSeguimientoMicro(params);
        dispatch(setReporteSeguimientoMicro(reporteRes ?? []));
        dispatch(setShowBackdrop(false));
    }
);

export const { setReporteBasico, setReporteSatisfaccion, setReporteAjustesDetalle, setReporteAjustesPrincipal, setReporteSeguimientoMicro, setFechaInicio, setFechaFin, resetReport } = reporteSlice.actions;
export default reporteSlice.reducer;